import React, { Component } from 'react'
import { checkTranslation, chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class CHSelectType extends Component {

    state = {
        display: true,
        types: [
            { name: '{{lang}}Fun and Entertainment', icon: '/assets/icons/types/entertainment.png', description: 'Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', },
            { name: '{{lang}}University, School, Institute', icon: '/assets/icons/types/university.png', description: '{{lang}}Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', },
            { name: '{{lang}}Factory, Production', icon: '/assets/icons/types/factory.png', description: '{{lang}}Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', },
            { name: '{{lang}}Company, Brand', icon: '/assets/icons/types/company.png', description: '{{lang}}Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', },
            { name: '{{lang}}Local Business', icon: '/assets/icons/types/shop.png', description: '{{lang}}Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', },
            { name: '{{lang}}Celebrity, Public Figure', icon: '/assets/icons/types/celebrity.png', description: '{{lang}}Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', },
            { name: '{{lang}}Group, Team', icon: '/assets/icons/types/team.png', description: '{{lang}}Distinctio maxime architecto eius velit quasi quis natus libero temporibus necessitatibus', }
        ],
    }

    componentDidMount() {
        // if (this.setHeader) {
        //     this.setHeader({
        //         'toolbar': null,
        //         'showToolbar': false,
        //         'info': 'Create Hub | Type',
        //         topHeaderComponent: this.topHeaderComponent,
        //         backAction: () => this.props.lastStage()
        //     })
        // }

        this.props.showHeader(true, () => {

            if (this.props.setHeader) {
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    isPortal: true,
                    doNotshowNotification: true,
                    showSettings: false,
                    'title': 'Create Hub | Type',
                    create: true,
                    topHeaderComponent: this.topHeaderComponent,
                    backAction: () => this.props.lastStage()
                })
            }
        })

        // this.props.showHeader(true, () => {

        //     if (this.props.setHeader) {
        //         // this.props.setHeader("dummy",1)
        //         this.props.setHeader({
        //             'toolbar': null,
        //             'showToolbar': false,
        //             // 'title': `${this.props.user?.info?.fullname}`,
        //             isPortal: true,
        //             doNotshowNotification: true,
        //             showSettings: false,
        //             create: true,
        //             'title': "{{lang}}Create Hub | Info",
        //             topHeaderComponent: this.topHeaderComponent,
        //             backAction: () => this.props.lastStage()
        //         })
        //     }
        // })
    }

    // setHeader = (key, value) => {
    //     if (this.header) {
    //         if (typeof key == 'object') {
    //             let object = {
    //                 showSettings: true,
    //                 showFrames: 'static'
    //             }
    //             if (this.props.defaultHeaderConfig) {
    //                 object = { ...this.props.defaultHeaderConfig }
    //             }
    //             for (const [okey, ovalue] of Object.entries(key)) {
    //                 object[okey] = ovalue
    //             }
    //             if (object.showSettings && this.props.showSettings) {
    //                 object.showSettings = this.props.showSettings
    //             }
    //             this.setState({ headerConfig: object }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //         else {
    //             this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //     }
    // }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextClicked}
                    isLoading={this.state.isLoading}
                    title={translate("Next Step")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }

    nextClicked = () => {
        if (this.props.initData?.category) {
            this.props.changeStage("info")
            // this.props.changeStage("pricing")
        }
        // else {
        //     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.ContentEmpty' })
        // }
    }

    changeType = (prop, index) => {
        this.props.setData({ category: prop.name }, () => {
        })
    }

    toggleDisplay = () => {
        this.setState(prevState => ({
            display: !prevState.display
        }))
    }

    render() {
        return (
            <div className=" w-100 h-100 scroll-no-scrollbar  position-relative window-content-radius" style={{}}>
                {/* <div className='w-100' style={{ position: 'sticky', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className=' w-100 flexc flex-column' style={{ padding: '4% 3%', background: "rgba(245, 228, 255, 35%)" }} >
                    <div className='px-1 br-10 bg-white' style={{}}>
                        <p className='px-4 pt-4 font-size-16 weight-600 main-c2'>Select Type of your business</p>
                        <div className='px-2 pb-5 d-flex flex-wrap mt-4' style={{}}>
                            {this.state.types.map((prop, index) => {
                                return (
                                    <Responsive width={this.props.width} media={{ xs: "12", sm: '6', md: '4', lg: '3', xl: '3' }}>
                                        <div onClick={() => this.changeType(prop, index)} className='w-100 d-flex flex-column py-3 px-3 h-100 cursor-pointer' style={{ border: this.props.initData?.category == prop.name ? '2px dashed #f932642b' : '2px dashed transparent', background: this.props.initData?.category == prop.name ? '#fec6d42b' : 'transparent', borderRadius: 16 }}>
                                            <div>
                                                <img className='' src={prop.icon} height={40} />
                                            </div>
                                            <p className='text-small text-semibold mt-1'>{checkTranslation(prop.name)}</p>
                                            <p className='text-smallest mt-1'>{checkTranslation(prop.description)}</p>

                                        </div>
                                    </Responsive>
                                )
                            })}

                        </div>
                    </div>
                </div>
            </div>
            // old version
            // <div className=" w-100 h-100 scroll-no-scrollbar  position-relative" style={{ backgroundColor: '#E1D9E8' }}>
            //     <div className='flexcc w-100'>

            //         <Responsive width={this.props.width} media={{ xs: "12", md: '8', lg: "8", xl: "8" }}>
            //             <div className=' w-100 flexc flex-column' style={{ padding: '0px 4%' }} >
            //                 <div className='' style={{ paddingTop: '3%' }}>


            //                     <div style={{ position: 'sticky', top: 0, backgroundColor: '#E1D9E8' }}>
            //                         <div className='px-2 pb-2 flexcb back-blur pt-0 w-100 pt-2' >
            //                             <div>
            //                                 <div className='flexc  p'>
            //                                     <div className='flexcc' style={{ backgroundColor: '#78419230', height: 24, width: 24, borderRadius: 20 }}>
            //                                         <p className=' text-bold' style={{ color: '#24113C' }}>1</p>
            //                                     </div>
            //                                     <h2 className="mt-0 text-normal mb-0 mx-2" style={{ color: '#24113C' }} >{translate('Create Hub | Type')}</h2>
            //                                 </div>

            //                             </div>


            //                             <div className='flexc'>
            //                                 <div>
            //                                     <button onClick={() => this.nextClicked()} className='px-1 py-1  flexcc' style={{ filter: this.props.initData?.category == null ? 'saturate(20%) ' : '', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
            //                                         <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Next Step")}</p>

            //                                         <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
            //                                             <img className='invert rtl-button' src='/assets/icons/angle-right.svg' height={18} />
            //                                         </div>
            //                                     </button>
            //                                 </div>
            //                             </div>
            //                         </div>

            //                         <div className='px-1'>
            //                             <div className='w-100 bg-white' style={{ height: 16, borderRadius: '16px 16px 0px 0px', transform: 'translateY(1px)', marginTop: -1 }}></div>
            //                         </div>
            //                     </div>


            //                     <div className='px-1' style={{ marginTop: -16 }}>
            //                         <div className='px-4 pb-5 pt-1 mb-4' style={{ backgroundColor: '#fff', borderRadius: '16px 16px 16px 16px' }}>
            //                             <div className='d-flex flex-wrap mt-4'>



            //                                 {this.state.types.map((prop, index) => {
            //                                     return (
            //                                         <Responsive width={this.props.width} media={{ xs: "6", md: '6', lg: '4', xl: '4' }}>
            //                                             <div onClick={() => this.changeType(prop, index)} className='w-100 d-flex flex-column py-3 px-3 h-100 cursor-pointer' style={{ backgroundColor: this.props.initData?.category == prop.name ? '#f2f6f8' : '', border: this.props.initData?.category == prop.name ? '2px dashed #eee' : '2px dashed transparent', borderRadius: 16 }}>
            //                                                 <div>
            //                                                     <img className='' src={prop.icon} height={40} />
            //                                                 </div>
            //                                                 <p className='text-small text-semibold mt-1'>{checkTranslation(prop.name)}</p>
            //                                                 <p className='text-smallest mt-1'>{checkTranslation(prop.description)}</p>

            //                                             </div>
            //                                         </Responsive>
            //                                     )
            //                                 })}
            //                             </div>


            //                         </div>
            //                     </div>
            //                 </div>
            //             </div>
            //         </Responsive>


            //         <Responsive width={this.props.width} height="100%" media={{ xs: "none", md: '4', lg: "4", xl: "4" }}>
            //             <div className=' p-4 w-100 h-100 d-flex' >
            //                 <div className='px-4 py-4' style={{ backgroundColor: '#ffffffee', borderRadius: 8, flex: 1 }}>
            //                     <h2 className=" text-big mb-0" >{translate('Intro and Features')}</h2>
            //                     <p className="mt-1 text-small" >{translate('What is a hub? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
            //                 </div>
            //             </div>
            //         </Responsive>

            //     </div>


            // </div>

        )
    }
}

// const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(CHSelectType);
export default CHSelectType;